import { render, staticRenderFns } from "./addZhiwei.vue?vue&type=template&id=7339bd16&scoped=true&"
import script from "./addZhiwei.vue?vue&type=script&lang=js&"
export * from "./addZhiwei.vue?vue&type=script&lang=js&"
import style0 from "./addZhiwei.vue?vue&type=style&index=0&id=7339bd16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339bd16",
  null
  
)

export default component.exports